<template>
  <vx-card :title="$t('class-room.class-section')" v-if="showClassSection && !local.isProcessing">

    <div class="vx-row">
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <ValidationProvider :name="$t('class-room.class-section')" rules="required" v-slot="{ errors }">
          <label class="text-sm">{{$t('class-room.class-section') + ' *'}}</label>
          <v-select :dir="$vs.rtl ? 'rtl' : 'ltr'" :name="$t('class-room.class-section')"
                    selectOnTab
                    @input="onSelectedSectionNo"
                    :options="classSections" class="w-full mb-1"
                    v-model="form.classSection.sectionNo">
          </v-select>
          <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
        </ValidationProvider>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <ValidationProvider :name="$t('class-room.class-section-start-class-date')" rules="required"
                            v-slot="{ errors }">
          <label class="text-sm">{{$t('class-room.class-section-start-class-date') + ' *'}}</label>
          <datepicker :disabledDates="disabledStartDates" :format="dateTimeFormat.yyyymmdd"
                      v-model="form.classSection.startClassDate"></datepicker>
          <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
        </ValidationProvider>
      </div>
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <ValidationProvider :name="$t('class-room.class-section-learn-span-no')" rules="required|numeric"
                            v-slot="{ errors }">
          <label class="text-sm">{{$t('class-room.class-section-learn-span-no') + ' *'}}</label>
          <vs-input :description-text="$t('class-room.class-section-learn-span-no-description')"
                    v-model.number="form.classSection.learnSpanNo"/>
          <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
        </ValidationProvider>
      </div>
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <ValidationProvider :name="$t('class-room.class-section-exam-span-no')" rules="required|numeric"
                            v-slot="{ errors }">
          <label class="text-sm">{{$t('class-room.class-section-exam-span-no') + ' *'}}</label>
          <vs-input :description-text="$t('class-room.class-section-exam-span-no-description')"
                    v-model.number="form.classSection.examSpanNo"/>
          <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
        </ValidationProvider>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <label class="text-sm">{{$t('class-room.class-section-description-local')}}</label>
        <vs-textarea rows="3" v-model="form.classSection.descriptionLocal"/>
      </div>
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <label class="text-sm">{{$t('class-room.class-section-description-eng')}}</label>
        <vs-textarea rows="3" v-model="form.classSection.descriptionEng"/>
      </div>
    </div>

  </vx-card>

</template>

<script>
  import {state} from '../data';
  import Datepicker from 'vuejs-datepicker';
  import moment from 'moment';
  import vSelect from 'vue-select';
  import {dateTimeFormat} from '@/utils/format'
  import * as _ from 'lodash'

  export default {
    props: {
      parentMethods: Object,
    },
    components: {
      vSelect,
      Datepicker,
    },
    data() {
      return {
        local: state.local,
        store: state.store,
        form: state.local.form,
        dateTimeFormat: dateTimeFormat,
      }
    },
    computed: {
      showClassSection() {
        if (this.local.courseOutline
          && this.local.selectedVdoSet && this.local.selectedVdoSet.id
          && this.local.selectedSubject && this.local.selectedSubject.id
          && this.local.selectedTeacher && this.local.selectedTeacher.id
          && this.local.courseOutlineRegistration && this.local.courseOutlineRegistration.id
        ) {
          return true;
        }
        return false;
      },
      disabledStartDates() {
        if (this.local.selectedClassRoomOwned && this.local.selectedClassRoomOwned.startDate) {

          let startDate = moment(this.local.selectedClassRoomOwned.startDate);
          let endDate = moment(this.local.selectedClassRoomOwned.endDate);

          return {
            from: new Date(endDate.year(), endDate.month(), endDate.date()),
            to: new Date(startDate.year(), startDate.month(), startDate.date()),
          };
        } else {
          return {
            from: new Date(),
          };
        }
      },
      classSections(){
        //filter only available class section
        let availableSections = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
        this.local.courseOutlineRegistration.classSections.forEach(item => {
          if(item.classRoom && item.classRoom.id){

            if(this.$route.params.id && item.sectionNo === this.form.classSection.sectionNo){
              //not pull
            }else{
              _.pull(availableSections, item.sectionNo);
            }

          }
        });

        return availableSections;
      }
    },
    methods: {
      onSelectedSectionNo() {
        this.parentMethods.filterClassSection();
        this.parentMethods.setRoomName();
      },
    },
  }
</script>

<style lang="scss" scoped>
  // @import 'common-scoped";
</style>
